<template>
  <el-dialog title="智能设备" center :visible.sync="dialogVisible" :close-on-click-modal="false" width="60%"
    :before-close="handleClose" :destroy-on-close="true">
    <div>
      <el-form inline ref="uform" :model="formData">
        <el-form-item prop="projectId">
          <el-select v-model="formData.projectId" clearable placeholder="请选择项目名称" @change="projectChange">
            <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
              :value="item.projectId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="deviceType">
          <el-select clearable v-model="formData.deviceType" placeholder="请选择设备类型" @change="deviceTypeChange">
            <el-option v-for="item in deviveTypeList" :key="item.dicId" :label="item.dicValue" :value="item.dicCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="deviceStatus">
          <el-select clearable v-model="formData.deviceStatus" placeholder="请选择设备状态" @change="statusChange">
            <el-option label="在线" value="1"></el-option>
            <el-option label="离线" value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-table :data="tableData" border>
        <el-table-column prop="deviceProductName" label="设备类型"></el-table-column>
        <el-table-column prop="deviceName" label="设备名称"></el-table-column>
        <el-table-column prop="deviceNumber" label="设备串号"></el-table-column>
        <el-table-column prop="deviceStatus" label="设备状态">
          <template v-slot="{ row }">
            <span>{{ row.deviceStatus === '1' ? '在线' : '离线' }}</span>
          </template>
        </el-table-column>
      </el-table>

      <GlobalPagination :total="total" :current-page.sync="page" :page-size.sync="size" @current-change="getDevice"
        @size-change="getDevice"></GlobalPagination>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'DeviceDialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    projectId: {
      type: String,
      default: ''
    }
  },
  computed: {
    projectList() {
      return this.$store.state.projectList
    }
  },
  watch: {
    projectId(val) {
      this.formData.projectId = this.projectId
      this.getDevice()
    },
    'dialogVisible'(val) {
      this.getDevice()
    }
  },
  created() {
    this.formData.projectId = this.projectId
    this.getDeviceType()
    this.getDevice()
  },
  data() {
    return {
      formData: {
        projectId: '',
        deviceType: '',
        deviceStatus: ''
      },
      deviveTypeList: [],
      tableData: [],
      deviceList: [],
      total: 0,
      page: 1,
      size: 10
    }
  },
  methods: {
    // 项目选择
    projectChange(val) {
      this.page = 1
      this.size = 10
      this.formData.projectId = val
      this.getDevice()
    },
    // 设备类型选择
    deviceTypeChange(val) {
      this.page = 1
      this.size = 10
      this.formData.deviceType = val
      this.getDevice()
    },
    // 设备状态选择
    statusChange(val) {
      this.page = 1
      this.size = 10
      this.formData.deviceStatus = val
      this.getDevice()
    },
    // 获取字典内设备类型
    getDeviceType() {
      this.$axios.get(this.$apis.system.selectDicByPage, {
        page: 1,
        size: 200,
        projectId: this.projectId
      }).then(res => {
        this.deviveTypeList = res.list.filter(item => item.dicType === 'deviceType')
      })
    },
    // 获取设备
    getDevice() {
      this.$axios.get(this.$apis.device.selectDeviceList, {
        page: this.page,
        size: this.size,
        projectId: this.formData.projectId,
        deviceStatus: this.formData.deviceStatus,
        deviceProduct: this.formData.deviceType
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      })
    },
    handleClose() {
      this.page = 1
      this.formData = {
        projectId: this.projectId,
        deviceType: '',
        deviceStatus: ''
      }
      this.$emit('update:dialogVisible', false)
    },
  }

}
</script>

<style scoped lang="scss">
::v-deep .el-dialog__body {
  padding: 0px 25px 30px 25px;
}

::v-deep .el-dialog__header {
  background: #fff;
  height: 50px;
  line-height: 50px;

  .el-dialog__headerbtn i {
    color: #000;
  }

  .el-dialog__title {
    color: #000;
    font-size: 20px;
  }
}
</style>